import { useUserRolePermissionStore } from "contexts/RootStore.context";
import useDevice from "hooks/useDevice";
import usePageVisibility from "hooks/usePageVisibility";
import { useEffect } from "react";
import { MapStore } from "stores/MapStore";

export default function usePolling(pollingTime: number, mapStoreObj: MapStore) {

  const { isMobileDevice } = useDevice();
  const { windowIsVisible } = usePageVisibility();
  const { canViewAssets, canViewUsers } = useUserRolePermissionStore()

  useEffect(() => {
    if (!windowIsVisible)
      return
    // call GET assets & users at every interval, and update markers with data returned from API.
    // only to run if permissions are enabled
    const PollingInterval = setInterval(() => {
      if (!isMobileDevice && canViewUsers) {
        // disable users on mobile.
        mapStoreObj.loadUsers();
      }
      if (canViewAssets)
        mapStoreObj.loadAssets();
    }, pollingTime * 1000); // multiply by 1000 to get correct seconds

    return () => {
      clearInterval(PollingInterval);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [windowIsVisible, isMobileDevice])
}